// extracted by mini-css-extract-plugin
export var formContainer = "_c5-0";
export var message = "_c5-1";